export enum AuthenticationRoutesEnum {
  LOGIN = '',
  REGISTER = 'registration/:token',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password/:token',
  EXPIRED_PASSWORD = 'expired-password/:token',
  TWO_FACTOR_CHECK = '2fa',
}
